module.exports = __webpack_public_path__ + "img/HomeImage.b6640ad3.svg";